export const GET_TOPIC_UIDS = "getTopicUids";
export const HAS_ERROR = "hasError";
export const LOADED = "loaded";
